import Text from '@/components/Text'
import { hexToRGBA } from '@/lib/colors'
import { CategoryCard } from '@/shared/api-generated-types'
import Link from 'next/link'
import { useMemo } from 'react'
import * as styles from './style'
export interface Props extends Partial<CategoryCard> {
  fixedDimensions?: boolean
}

const Category = ({ title, backgroundColor, iconUrl, slug, fixedDimensions = false }: Props): JSX.Element => {
  const iconBackground = useMemo(() => {
    if (!backgroundColor) return
    return { backgroundColor: hexToRGBA(backgroundColor, 0.15) }
  }, [backgroundColor])
  const titleBackground = useMemo(() => {
    if (!backgroundColor) return
    return { backgroundColor }
  }, [backgroundColor])
  return (
    <Link href={`/category/${slug}`}>
      <div className={styles.root}>
        <div
          className={`${styles.iconContainer} ${fixedDimensions ? styles.fixedDimensions : ''}`}
          style={iconBackground}
        >
          {iconUrl && <img src={iconUrl} alt={`${slug} logo`} loading="lazy" />}
        </div>
        <div className={styles.titleContainer} style={titleBackground}>
          <Text
            className="ellipsis-1L p-0"
            weight="lg"
            size="xs"
            responsiveSize={{
              sm: 'sm',
            }}
          >
            {title}
          </Text>
        </div>
      </div>
    </Link>
  )
}
export default Category
